import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// Se o erro 404 persistir e você não puder mexer no servidor, 
// troque a linha acima por: import { HashRouter as Router, Routes, Route } from 'react-router-dom';

import Header from './components/widget/Header';
import Footer from './components/widget/Footer';
import Home from './pages/Home';
import Login from './pages/Login';

// Importe os outros componentes quando for descomentar as rotas
// import About from './pages/About';
// import Portfolio from './pages/Portfolio';
// import Contact from './pages/Contact';

function App() {
  return (
    <Router>
      {/* O Header e Footer ficam fora do Routes para aparecerem em todas as páginas */}
      <Header />

      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />

          {/* Rotas futuras - Basta descomentar aqui e o import acima */}
          {/* <Route path="/about" element={<About />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/contact" element={<Contact />} /> 
          */}

          {/* Rota de fallback: se o usuário digitar algo inexistente, manda para Home */}
          <Route path="*" element={<Home />} />
        </Routes>
      </main>

      <Footer />
    </Router>
  );
}

export default App;